// extracted by mini-css-extract-plugin
module.exports = {"root":"PostCard-module--root--Oau6e","card":"PostCard-module--card--2W9N8","image":"PostCard-module--image--3uNIj","info":"PostCard-module--info--3xh7F"};